<div *ngIf="viewType === 'read'" [dir]="textDir">
    <div class="top-header-sm">
        <label class="form-title">{{groupData?.name}} {{'group' | translate}}</label>
    </div>
    <div class="pre-white white pad20" style="width:430px; height:340px;">
        <div class="nomargin marT10">
            <div class="flexStart">
                <label class="label-wid label-light">{{'Group name' | translate}}</label>
                <div class="txtW" [dir]="textDir">
                    <label class="labeltxt">{{groupData?.name}}</label>
                </div>
            </div>
        </div>
        <div class="nomargin marT20">
            <div class="flexStart">
                <label class="label-wid label-light">{{'Class' | translate}}</label>
                <div class="txtW" [dir]="textDir">
                    <label class="labeltxt">{{myClass?.name}}</label>
                </div>
            </div>
        </div>
        <div class="nomargin marT20">
            <div class="flexStart">
                <label class="label-wid label-light">{{'Description' | translate}}</label>
                <div class="txtW" [dir]="textDir">
                    <label class="labeltxt">{{groupData?.description}}</label>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="nomargin marT20">
            <div class="flexStart">
                <label class="label-wid label-light">{{'Students' | translate}}</label>
                <div class="txtW">
                    <ng-container *ngFor="let item of groupData?.students">
                        <div>
                            <label class="labeltxt" style="text-transform: capitalize;">{{item?.first_name}} {{item?.last_name}}</label>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<form enctype="multipart/form-data" [formGroup]="myForm" *ngIf="viewType !== 'read'" [dir]="textDir">
    <div class="top-header-sm">
        <label class="form-title" *ngIf="viewType !== 'edit'">{{'Add a new group' | translate}}</label>
        <label class="form-title" *ngIf="viewType === 'edit'">{{groupData?.name}} group</label>
    </div>
    <div class="pre-white white pad20" [ngClass]="viewType == 'edit'? 'editHeight': 'addNewHeight'" style="overflow-y:auto;">
        
        <div class="form-group sm-12 flexStart padT5">
            <label class="label-wid label-light">{{'Group name' | translate}}</label>
            <div class="txtW">
                <input id="groupName"
                type="text"
                class="form-control txtW"
                placeholder="Insert group name"
                formControlName="name" maxlength="40" (change)="formChange()" [dir]="textDir"/>
                <div *ngIf="this.myForm.get('name').invalid &&
                (this.myForm.get('name').dirty ||
                this.myForm.get('name').touched)"
                class="alert alert-danger">
                <div *ngIf="this.myForm.get('name').errors &&
                    this.myForm.get('name').errors?.required">
                    {{'Name is required' | translate}}.
                </div>
                <div *ngIf="this.myForm.get('name').errors &&
                    this.myForm.get('name').errors?.maxlength">
                    {{'Name must be less then 40 characters long.'  | translate}}
                </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group sm-12 flexStart  padT15" >
            <label class="label-wid grey_text">{{'Class' | translate}}</label>
            <div class="txtW" >
                <label>{{myClass?.name}}</label>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group sm-12 flexStart padT15">
            <label class="label-wid label-light">{{'Description' | translate}}</label>
            <div class="txtW">
                <textarea class="form-control txtW txtarea-hgt"
                placeholder="Enter group description here (max. 120 characters)"
                formControlName="description"
                maxlength="120 "
                cols="5" rows="4"
                (change)="formChange()" [dir]="textDir"></textarea>
                <div *ngIf="this.myForm.get('description').invalid &&
                    this.myForm.get('description').value"
                    class="alert alert-danger">
                    <div *ngIf="this.myForm.get('description').errors &&
                        this.myForm.get('description').errors?.maxlength">
                       {{'Description must be less then 120 characters long.' | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group sm-12 flexStart padT15">
            <label class="label-wid label-light">{{'Add students' | translate}}</label>
            <div class="txtW" [dir]="textDir">
                <div class="slist" formArrayName="students">
                    <ng-container *ngFor="let item of myStudentsList;let i = index">
                        <div class="checkbox">
                            <input type="checkbox" id="{{'cb2'+i}}" [checked]="isChecked(item)" (input)="checkUncheckSubject(item,$event)" [dir]="textDir">
                            <label class="labeltxt" for="{{'cb2'+i}}"> {{item?.first_name | ucfirst}} {{item?.last_name | ucfirst}}</label>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</form>

